/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whatwedo_Marketing2Inputs */

const ja_careers_whatwedo_marketing2 = /** @type {(inputs: Careers_Whatwedo_Marketing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーマーへのマーケティング`)
};

const en_careers_whatwedo_marketing2 = /** @type {(inputs: Careers_Whatwedo_Marketing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing for Gamers`)
};

/**
* | output |
* | --- |
* | "Marketing for Gamers" |
*
* @param {Careers_Whatwedo_Marketing2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whatwedo_marketing2 = /** @type {((inputs?: Careers_Whatwedo_Marketing2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whatwedo_Marketing2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whatwedo_marketing2(inputs)
	return en_careers_whatwedo_marketing2(inputs)
});
export { careers_whatwedo_marketing2 as "careers_whatWeDo_marketing" }